import type { ReactNode } from "react";

interface FieldProps {
  label: string;
  htmlFor: string;
  hint?: string;
  error?: string | null;
  children: ReactNode;
}

/**
 * A labelled form field: label, optional hint, control, optional error.
 *
 * The column is a full-height flex box and the control carries `mt-auto`, so
 * every control on one grid row sits on the SAME baseline no matter how many
 * lines each field's hint wraps to. Without this, a two-line hint drops its
 * input below its neighbours' and the row looks broken.
 */
export function Field({ label, htmlFor, hint, error, children }: FieldProps) {
  return (
    <div className="flex h-full flex-col">
      <label htmlFor={htmlFor} className="block text-sm font-semibold text-ink">
        {label}
      </label>
      {hint ? (
        <p className="mt-1.5 text-xs leading-relaxed text-ink-soft">{hint}</p>
      ) : null}
      <div className="mt-auto pt-2.5">{children}</div>
      {error ? <p className="mt-1.5 text-sm text-crimson">{error}</p> : null}
    </div>
  );
}
